import React, { useCallback } from "react"
import { Formik, FormikHelpers } from "formik"
import { FormStep, ValidationProvider } from "@theguarantors/ui-kit-v2"
import { useSelector, useDispatch } from "react-redux"
import { submitForm as noApartmentFormSubmit } from "../../../../actions/noApartment"
import { NoApartmentFormValues } from "./NoApartmentForm.types"
import { FormStatuses } from "@theguarantors/frontend-core/dist/types/formik"
import { LGQuestionnaireStore } from "../../../../types/store.types"
import { validationSchema } from "./NoApartmentForm.validate"
import { NoApartmentSuccessPage } from "./NoApartmentSuccessPage"
import { NoApartmentFormComponent } from "./NoApartmentForm.component"

const initialValues: NoApartmentFormValues = {
  email: "",
  details: ""
}

export const NoApartmentForm: React.FC = () => {
  const formStatus = useSelector((state: LGQuestionnaireStore) => state.noApartment.status)
  const dispatch = useDispatch()
  const handleFormikSubmit = useCallback(
    (values: NoApartmentFormValues, { setSubmitting, setErrors }: FormikHelpers<NoApartmentFormValues>) => {
      const { brokerName, brokerEmail, ...rest } = values
      dispatch(
        noApartmentFormSubmit(
          {
            ...rest,
            // NOTE: fields that have empty string as a value should not be sent to the server
            brokerName: brokerName ? brokerName : undefined,
            brokerEmail: brokerEmail ? brokerEmail : undefined
          },
          { setSubmitting, setErrors }
        )
      )
    },
    [dispatch]
  )
  if (formStatus === FormStatuses.success) {
    return <NoApartmentSuccessPage />
  }

  return (
    <FormStep.Wrapper>
      <FormStep.Title data-testid="headline">Haven't found an apartment yet?</FormStep.Title>
      <FormStep.Subtitle as="p" mt="0" data-testid="subheadline">
        Please provide your email address and a description and someone from our team will contact you.
      </FormStep.Subtitle>
      <FormStep.Content>
        <ValidationProvider value={validationSchema}>
          <Formik
            initialValues={initialValues}
            component={NoApartmentFormComponent}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={handleFormikSubmit}
          />
        </ValidationProvider>
      </FormStep.Content>
    </FormStep.Wrapper>
  )
}
